import { isEmpty } from '../utils/utils';
import { commonConst } from '../constants/constants';

const ROOT_API = process.env.ROOT_API;

export function generationUrl(currentText, currentLang, currentAlphabet, currentPage, currentCatId) {
  const {
    defaultLang,
    defaultText,
    defaultAlphabet,
    defaultActivePage,
    defaultPageSize,
    defaultCategory,
  } = commonConst;
  const text = isEmpty(currentText) ? defaultText : encodeURI(currentText);
  const lang = isEmpty(currentLang) ? defaultLang : currentLang;
  const alphabet = isEmpty(currentAlphabet) ? defaultAlphabet : currentAlphabet;
  const page = isEmpty(currentPage) ? defaultActivePage : currentPage;
  const catId = isEmpty(currentCatId) ? defaultCategory : currentCatId;
  let url = `${ROOT_API}term/without-text?alphabet=${encodeURI(alphabet)}&lang=${lang}&pageIndex=${page}&pageSize=${defaultPageSize}`;
  let checkUrlEndChar = url.endsWith('?');
  if (!isEmpty(text)) {
    if (text.length === 1) {
      url = `${ROOT_API}term/single-text?text=${text}&lang=${lang}&pageIndex=${page}&pageSize=${defaultPageSize}`;
    } else {
      url = `${ROOT_API}term/with-text?text=${text}&lang=${lang}&pageIndex=${page}&pageSize=${defaultPageSize}`;
    }
  } else {
    url = `${ROOT_API}term/without-text?`;
    checkUrlEndChar = url.endsWith('?');
    if (!isEmpty(alphabet)) {
      if (!checkUrlEndChar) {
        url += '&';
      }
      if (alphabet === '0-9') {
        url += `alphabet=${encodeURI('-')}`;
      } else {
        url += `alphabet=${encodeURI(alphabet)}`;
      }
    }

    checkUrlEndChar = url.endsWith('?');
    if (!isEmpty(catId)) {
      if (!checkUrlEndChar) {
        url += '&';
      }
      url += `catId=${catId}`;
    }

    checkUrlEndChar = url.endsWith('?');
    if (!checkUrlEndChar) {
      url += '&';
    }
    url += `lang=${lang}&pageIndex=${page}&pageSize=${defaultPageSize}`;
  }
  return url;
}

export function generateDetailLink(language, id) {
  let detailLink = `/${id}`;
  if (language === 'en') {
    detailLink = `/${id}?hl=${language}`;
  }
  return detailLink;
}

export function combineTitle(language, title, titleEn) {
  let combineTitle = '';
  if (language === 'vn') {
    if (!isEmpty(titleEn)) {
      if (!isEmpty(title)) {
        combineTitle = `${title} / ${titleEn}`;
      } else {
        combineTitle = titleEn;
      }
    } else {
      combineTitle = title;
    }
  } else if (!isEmpty(title)) {
    if (!isEmpty(titleEn)) {
      combineTitle = `${titleEn} / ${title}`;
    } else {
      combineTitle = title;
    }
  } else {
    combineTitle = titleEn;
  }
  return combineTitle;
}


export function combineTitleHeading(language, title, titleEn) {
  let combineTitle = '';
  if (language === 'vn') {
    if (!isEmpty(titleEn)) {
      if (!isEmpty(title)) {
        combineTitle = `${title} <span>${titleEn}</span>`;
      } else {
        combineTitle = titleEn;
      }
    } else {
      combineTitle = title;
    }
  } else if (!isEmpty(title)) {
    if (!isEmpty(titleEn)) {
      combineTitle = `${titleEn} <span>${title}</span>`;
    } else {
      combineTitle = title;
    }
  } else {
    combineTitle = titleEn;
  }
  return combineTitle;
}
